module.exports = __webpack_public_path__ + "img/bar-chart-07.39334b45.svg";